module.exports = __webpack_public_path__ + "img/1722496631622-4858f881-71d6-4fc5-aaea-3076d6c92244.jpeg.b321016a.webp";